(() => {
  document.addEventListener('click', (e) => {
    const root = e.target.closest('.js-subscription');
    if (!root) return;

    // Laisse le comportement natif si on clique un vrai contrôle
    if (e.target.closest('select, input, label, button, a, edit-class')) return;

    // Si l'abonnement est déjà actif, on ne togglera pas ; on force juste un "change"
    const alreadyChecked = root.querySelector('#subscription-checked.is-active');
    if (alreadyChecked) {
      const sel = root.querySelector('#subscription-options');
      if (sel) {
        sel.dispatchEvent(new Event('input', { bubbles: true }));
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        const r = root.querySelector('input[name="selling_plan"]:checked');
        if (r) r.dispatchEvent(new Event('change', { bubbles: true }));
      }
      return;
    }

    // Sinon, on clique le <edit-class> "unchecked" pour activer l'abonnement
    const unchecked = root.querySelector('#subscription-unchecked.is-active') || root.querySelector('#subscription-unchecked');
    if (unchecked) {
      unchecked.click(); // -> laisse le thème gérer les classes & inputs

      // Après activation, on redéclenche un "change" sur le plan déjà sélectionné
      setTimeout(() => {
        const sel = root.querySelector('#subscription-options');
        if (sel) {
          sel.dispatchEvent(new Event('input', { bubbles: true }));
          sel.dispatchEvent(new Event('change', { bubbles: true }));
        } else {
          const r = root.querySelector('input[name="selling_plan"]:checked');
          if (r) r.dispatchEvent(new Event('change', { bubbles: true }));
        }
      }, 0);
    }
  });
})();
